import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_grimoirespells, s_char_inventarSpells} from "../_signals/s_char";
import {ICharInventarSpell} from "../_interfaces/ICharInventarSpell";
import {ICharGrimoireSpell} from "../_interfaces/ICharGrimoireSpell";

export const GrimoireSpellsGet = (cid: string) => {
    fetch(apiAddress + "/char/grimoirespells/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                console.log('BEGrimoireSpells get reponse', data);
                if (data.hasOwnProperty('result')) {
                    s_char_grimoirespells.value = (data.result as ICharGrimoireSpell[])
                }
            }
        )
        .catch((reason => console.log('BEGrimoireSpells get catch', reason)))
}

export const GrimoireSpellsCreate = (spell: ICharGrimoireSpell) => {
    fetch(apiAddress + "/char/grimoirespells/", createOptions('CREATE', spell))
        .then((res) => res.json())
        .then((data) => console.log('BEGrimoireSpells create reponse', data))
        .catch((reason => console.log('BEGrimoireSpells create catch', reason)))
}

export const GrimoireSpellsUpdate = (spell: ICharGrimoireSpell) => {
    fetch(apiAddress + "/char/grimoirespells/", createOptions('UPDATE', spell))
        .then((res) => res.json())
        .then((data) => console.log('BEGrimoireSpells update response', data))
        .catch((reason => console.log('BEGrimoireSpells update catch', reason)))
}

export const GrimoireSpellsDelete=(spell: ICharGrimoireSpell)=> {
    fetch(apiAddress + "/char/grimoirespells/", createOptions('DELETE', spell))
        .then((res) => res.json())
        .then((data) => console.log('BEGrimoireSpells delete response', data))
        .catch((reason => console.log('BEGrimoireSpells delete catch', reason)))
}